var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"special-instructions-text-container"},[_c('BaseResizeableTextArea',{attrs:{"inputVal":_vm.userInstructions,"classNames":"input special-instructions-input text-input","placeHolder":"Enter additional notes for your order here","ariaLabel":"Enter any special notes for your order here"},on:{"input":_vm.updateSpecialInstructionText}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20a347e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/CheckoutSpecialInstructions.vue
// module id = null
// module chunks = 